module.exports = __webpack_public_path__ + "static/img/creator_flow.40730c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/creator_bank/img/creator_flow.png
// module id = 0/02
// module chunks = 0